module.exports = __webpack_public_path__ + "static/lowther-37fd1b35ae6c4f3236e5e60224bb053a.png";